import { render } from "./banner.vue?vue&type=template&id=0843e03a&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=0843e03a&lang=scss&scoped=true"

import exportComponent from "/data/heYou-h5/panther-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0843e03a"]])

export default __exports__